import { render, staticRenderFns } from "./LandingPhoneInput.vue?vue&type=template&id=43bc3ee8&scoped=true&"
import script from "./LandingPhoneInput.vue?vue&type=script&lang=ts&"
export * from "./LandingPhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPhoneInput.vue?vue&type=style&index=0&id=43bc3ee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc3ee8",
  null
  
)

export default component.exports